import './vendor/polyfills'
import './vendor/helpers'
import externalLinks from './modules/externalLinks'
import dropdowns from './modules/dropdowns'
import contentSets from './modules/contentSets'
import forms from './modules/forms'
import sliders from './modules/sliders'
import mobileDevices from './modules/mobileDevices'
import layout from './modules/layout'
import LazyLoad from 'vanilla-lazyload'
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
// import quicklink from 'quicklink/dist/quicklink.js'
var WebFont = require('webfontloader');

WebFont.load({
  google: {
    api: 'https://fonts.googleapis.com/css',
    families: [
      "Roboto:300;400;500;700",
      "EB+Garamond:400i@1&display=swap",
    ]
  }
});

window.lazyLoad = new LazyLoad({
  elements_selector: '.lazy',
  callback_loaded: el => {
    if (el instanceof HTMLImageElement) {
      objectFitImages(el)
    }
  },
})

document.addEventListener('DOMContentLoaded', () => {
  externalLinks()
  dropdowns()
  contentSets()
  forms()
  sliders()
  mobileDevices()
  document.querySelectorAll('.lightgallery').forEach(gallery => window.lightGallery(gallery))
})

// window.addEventListener('load', () => {
//   quicklink.listen({
//     priority: true,
//     timeout: 2000,
//     throttle: 3,
//     ignores: [
//       /tel:/g,
//       /mailto:/g,
//       /#(.+)/,
//       uri => uri.includes('tel:'),
//       uri => uri.includes('mailto:'),
//       uri => uri.includes('#')
//     ]
//   });
//   layout();
// })
